import React from 'react';

/** Texte d'aide : **gras** et [[Touche]] (touche du clavier) */
export function RichText({ text }: { text: string }) {
  const parts = text.split(/(\*\*[^*]+\*\*|\[\[[^\]]+\]\])/g).filter(Boolean);
  return (
    <>
      {parts.map((p, i) => {
        if (p.startsWith('**')) return <strong key={i} className="font-semibold text-slate-900">{p.slice(2, -2)}</strong>;
        if (p.startsWith('[[')) return <Kbd key={i}>{p.slice(2, -2)}</Kbd>;
        return <React.Fragment key={i}>{p}</React.Fragment>;
      })}
    </>
  );
}

export function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd className="mx-0.5 inline-flex min-w-[1.6em] items-center justify-center rounded-md border border-slate-300 border-b-2 bg-white px-1.5 py-px font-mono text-[0.85em] font-medium text-slate-700">
      {children}
    </kbd>
  );
}

/** Texte brut (recherche) : sans les marqueurs de mise en forme */
export const plainText = (text: string) => text.replace(/\*\*|\[\[|\]\]/g, '');
